/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

import { CardColorProps } from '../BaseIcon'

export const Applepay: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='#fff' />
        <g clipPath='url(#applepay-v2-a)'>
          <path d='M10.92 8.07a2 2 0 0 0 .51-1.49c-.5.02-1.11.31-1.46.71-.32.35-.6.9-.53 1.44a1.9 1.9 0 0 0 1.48-.66Zm.51.76c-.82-.05-1.52.43-1.9.43-.4 0-1-.4-1.64-.4-.84.01-1.62.46-2.05 1.17-.88 1.42-.23 3.52.62 4.68.42.57.92 1.2 1.58 1.18.62-.03.86-.38 1.62-.38.75 0 .97.38 1.63.37.69-.02 1.11-.58 1.53-1.15.47-.65.67-1.28.68-1.31-.01-.02-1.32-.48-1.33-1.9-.01-1.17 1.03-1.73 1.07-1.76a2.4 2.4 0 0 0-1.81-.93Zm7.11-1.59c1.78 0 3.02 1.14 3.02 2.81 0 1.68-1.27 2.83-3.06 2.83h-1.97v2.94h-1.42V7.24h3.43Zm-2 4.53h1.62c1.24 0 1.94-.63 1.94-1.71s-.7-1.7-1.93-1.7h-1.64v3.4Zm5.39 2.27c0-1.1.9-1.77 2.48-1.85l1.83-.1v-.48c0-.7-.5-1.12-1.34-1.12-.8 0-1.29.36-1.41.92h-1.3c.08-1.13 1.1-1.96 2.76-1.96 1.62 0 2.65.8 2.65 2.05v4.32h-1.31v-1.03h-.03a2.42 2.42 0 0 1-2.11 1.13c-1.3 0-2.22-.76-2.22-1.88Zm4.3-.57v-.5l-1.64.1c-.82.06-1.28.4-1.28.93 0 .55.48.9 1.22.9.96 0 1.7-.61 1.7-1.43Zm2.61 4.65v-1.04c.1.02.33.02.44.02.64 0 .98-.25 1.2-.9l.11-.38-2.41-6.26h1.48l1.7 5.1h.02l1.69-5.1h1.44l-2.5 6.58c-.57 1.52-1.23 2-2.61 2-.12 0-.46 0-.56-.02Z' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          />
        </g>
        <defs>
          <clipPath id='applepay-v2-a'>
            <path fill='#fff' d='M0 0h40v24H0z' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <g clipPath='url(#applepay-v1-a)'>
          <rect width='40' height='24' rx='2' fill='#fff' />
          <path d='M10.92 8.07a2 2 0 0 0 .51-1.49c-.5.02-1.11.31-1.46.71-.32.35-.6.9-.53 1.44a1.9 1.9 0 0 0 1.48-.66Zm.51.76c-.82-.05-1.52.43-1.9.43-.4 0-1-.4-1.64-.4-.84.01-1.62.46-2.05 1.17-.88 1.42-.23 3.52.62 4.68.42.57.92 1.2 1.58 1.18.62-.03.86-.38 1.62-.38.75 0 .97.38 1.63.37.69-.02 1.11-.58 1.53-1.15.47-.65.67-1.28.68-1.31-.01-.02-1.32-.48-1.33-1.9-.01-1.17 1.03-1.73 1.07-1.76a2.4 2.4 0 0 0-1.81-.93Zm7.11-1.59c1.78 0 3.02 1.14 3.02 2.81 0 1.68-1.27 2.83-3.06 2.83h-1.97v2.94h-1.42V7.24h3.43Zm-2 4.53h1.62c1.24 0 1.94-.63 1.94-1.71s-.7-1.7-1.93-1.7h-1.64v3.4Zm5.39 2.27c0-1.1.9-1.77 2.48-1.85l1.83-.1v-.48c0-.7-.5-1.12-1.34-1.12-.8 0-1.29.36-1.41.92h-1.3c.08-1.13 1.1-1.96 2.76-1.96 1.62 0 2.65.8 2.65 2.05v4.32h-1.31v-1.03h-.03a2.42 2.42 0 0 1-2.11 1.13c-1.3 0-2.22-.76-2.22-1.88Zm4.3-.57v-.5l-1.64.1c-.82.06-1.28.4-1.28.93 0 .55.48.9 1.22.9.96 0 1.7-.61 1.7-1.43Zm2.61 4.65v-1.04c.1.02.33.02.44.02.64 0 .98-.25 1.2-.9l.11-.38-2.4-6.26h1.48l1.68 5.1h.03l1.69-5.1h1.44l-2.5 6.58c-.57 1.52-1.23 2-2.61 2-.12 0-.46 0-.56-.02Z' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          />
        </g>
        <defs>
          <clipPath id='applepay-v1-a'>
            <rect width='40' height='24' rx='2' fill='#fff' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
